import { render, staticRenderFns } from "./user-identification-new-cable.vue?vue&type=template&id=383c7d8a&scoped=true"
import script from "./user-identification-new-cable.vue?vue&type=script&lang=js"
export * from "./user-identification-new-cable.vue?vue&type=script&lang=js"
import style0 from "./user-identification-new-cable.vue?vue&type=style&index=0&id=383c7d8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383c7d8a",
  null
  
)

export default component.exports